const cutLengthTo = (maxLength: number, startIndex = 0) => (value: string) => {
  const localStartIndex =
    maxLength + startIndex > value.length ? 0 : startIndex;

  return value.slice(localStartIndex, maxLength + startIndex);
};

export default cutLengthTo;
